export default "/_next/static/images/product_answer_bot-0551266729a8f01f5d88bc7599dfdb99.svg";